// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"s1-z"};